/**
 * Convert currency
 * @param moneyParam
 * @returns
 */
export const convertCurrency = (moneyParam: number): string => {
   return new Intl.NumberFormat("vi-vn").format(moneyParam)
}
